import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  page: 1,
  totalPages: 0,
  total: 0,
  limit: 10,
  data: []
};

const contactUs = (state = initialState, action) => {
  switch (action.type) {
    case constant.CONTACT_US_LOADING:
      return { ...state, loading: true };
    case constant.ADD_CONTACT_US_LIST:
      return {
        loaded: true,
        loading: false,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
        limit: action.payload.limit,
        total: action.payload.total,
        data: action.payload.data
      };
    default:
      return state;
  }
}



export default contactUs;